var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no_result"},[_c('p',[_vm._v("검색된 마이팩이 없습니다.")]),_vm._v(" "),_c('p',[_vm._v("입력하신 내용을 확인 후 다시 검색해 보세요.")])])}]

export { render, staticRenderFns }